module.exports = __webpack_public_path__ + "img/A1.31b43f90.png";